import type { GridProps } from '@chakra-ui/react';
import { Box, Text } from '@chakra-ui/react';
import type { PortableTextBlock } from '@portabletext/types';
import { Grid } from '@time-line/components/common';
import {
  RichTextResolver,
  SectionHeaderContainer,
} from 'components/common/RichTextResolver';

interface SectionHeaderProps extends GridProps {
  title: string;
  label?: string;
  description?: PortableTextBlock[];
}

export function SectionHeader({
  label,
  title,
  description,
  ...props
}: SectionHeaderProps) {
  return (
    <Grid {...props}>
      <Grid.Inner gridRowGap="3xs">
        {label && (
          <Text gridColumn="span 12" size="title2" as="span">
            {label}
          </Text>
        )}
        <Text
          as="h2"
          size="h2"
          whiteSpace="pre-wrap"
          gridColumn={{ base: 'span 12', md: 'span 6' }}
        >
          {title}
        </Text>
        {description && (
          <Box gridColumn={{ base: 'span 12', md: '8/-1' }}>
            <RichTextResolver
              container={SectionHeaderContainer}
              blocks={description}
            />
          </Box>
        )}
      </Grid.Inner>
    </Grid>
  );
}
